import { Controller } from "@hotwired/stimulus"

// Renders a Cloudflare Turnstile widget on every page, including pages
// reached by a Turbo visit.
//
// Cloudflare's api.js only scans for .cf-turnstile once, when the script
// first loads. After a Turbo visit the new page's widget stayed empty, the
// form posted no cf-turnstile-response, and the server refused it (the
// public contact form lost every inquiry from visitors who arrived from
// search or the directory). This controller renders the widget explicitly
// when it connects and removes it before Turbo caches the page.
export default class extends Controller {
  connect() {
    this.renderWhenReady()
  }

  disconnect() {
    clearTimeout(this.retry)
    if (this.widgetId !== undefined && window.turnstile) {
      try { window.turnstile.remove(this.widgetId) } catch (_) { /* already gone */ }
    }
    this.widgetId = undefined
    // Leave no dead iframe in the Turbo snapshot of this page.
    this.element.replaceChildren()
  }

  renderWhenReady() {
    if (!this.element.isConnected) return
    // Already rendered by api.js's own first-load scan.
    if (this.element.childElementCount > 0) return

    if (window.turnstile && typeof window.turnstile.render === "function") {
      this.widgetId = window.turnstile.render(this.element)
    } else {
      // api.js loads async; try again shortly.
      this.retry = setTimeout(() => this.renderWhenReady(), 100)
    }
  }
}
